(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/analysis-forecast.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/analysis-forecast.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectMatchAnalysIdsForSpecificDrawAndMatchAndEventNumber = svs.components.sportinfo.gameAnalysesRedux.selectors.selectMatchAnalysIdsForSpecificDrawAndMatchAndEventNumber;
const TipsinfoRowAnalysisForecast = svs.components.tipsen.tipsinfo.TipsinfoRowAnalysisForecast;
const useAnalysisOutcomes = svs.components.sportinfo.gameAnalysesRedux.hooks.useAnalysisOutcomes;
const _svs$components$sport = svs.components.sportinfo.gameAnalysesRedux.selectors,
  selectMatchAnalysis = _svs$components$sport.selectMatchAnalysis,
  selectAuthorProfile = _svs$components$sport.selectAuthorProfile;
const selectEngineDefinition = svs.components.tipsen.engine.selectors.selectEngineDefinition;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const getRowTitle = (isGoalCount, authorShortName) => {
  const lastChar = authorShortName.slice(-1).toLowerCase();
  const endsWithSorX = lastChar === 's' || lastChar === 'x';
  let rowTitle = '';
  if (isGoalCount) {
    rowTitle = "Spelanalys fr\xE5n ".concat(authorShortName);
  } else {
    rowTitle = endsWithSorX ? "".concat(authorShortName, " speltips") : "".concat(authorShortName, "s speltips");
  }
  return rowTitle;
};
const AnalysisForecastRow = _ref => {
  let analysisId = _ref.analysisId,
    _ref$dataTestId = _ref.dataTestId,
    dataTestId = _ref$dataTestId === void 0 ? '' : _ref$dataTestId,
    isGoalCount = _ref.isGoalCount;
  const matchAnalysis = useSelector(state => selectMatchAnalysis(state, analysisId));
  const authorProfile = useSelector(state => selectAuthorProfile(state, matchAnalysis === null || matchAnalysis === void 0 ? void 0 : matchAnalysis.authorId));
  const outcomes = useAnalysisOutcomes(matchAnalysis)[0];
  const outComesGoalCountDisplay = "".concat(outcomes.map(outcome => outcome.description).join(', '), " m\xE5l");
  const rowTitle = getRowTitle(isGoalCount, authorProfile.authorShortName);
  return React.createElement(TipsinfoRowAnalysisForecast, {
    className: "prognos",
    dataTestid: dataTestId,
    isGoalCount: isGoalCount,
    title: rowTitle
  }, isGoalCount ? outComesGoalCountDisplay : outcomes);
};
const AnalysisForecast = _ref2 => {
  let matchId = _ref2.matchId,
    dataTestid = _ref2.dataTestid,
    productId = _ref2.productId,
    drawId = _ref2.drawId,
    eventNumber = _ref2.eventNumber;
  const matchAnalysesIds = useSelector(state => selectMatchAnalysIdsForSpecificDrawAndMatchAndEventNumber(state, productId, drawId, matchId, eventNumber));
  const currentEngine = useSelector(selectEngineDefinition);
  const isGoalCount = currentEngine.outcomes.eventTypeId === EventTypeId.GOAL_COUNT;

  if (!matchAnalysesIds || matchAnalysesIds.length === 0) {
    return React.createElement(TipsinfoRowAnalysisForecast, {
      className: "prognos-no-data",
      dataTestid: dataTestid,
      isGoalCount: isGoalCount,
      title: "F\xF6r tillf\xE4llet har vi inga speltips"
    });
  }
  return React.createElement(React.Fragment, null, matchAnalysesIds.map(analysisId => React.createElement(AnalysisForecastRow, {
    analysisId: analysisId,
    dataTestid: dataTestid,
    isGoalCount: isGoalCount,
    key: analysisId
  })));
};
setGlobal('svs.components.tipsen.tipsinfo.AnalysisForecast', AnalysisForecast);

 })(window);